import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLayoutHost]',
})
export class LayoutHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
